export default {
  meta: {
    title: '品牌运营',
  },
};
